'use client';

import { useReportWebVitals } from 'next/web-vitals';

export function WebVitals() {
  useReportWebVitals((metric) => {
    // Determine the metric's status (good, needs improvement, poor)
    // based on standard Google Lighthouse/Core Web Vitals thresholds.
    let rating = 'good';
    
    switch (metric.name) {
      case 'LCP': // Largest Contentful Paint
        if (metric.value > 2500) rating = 'needs improvement';
        if (metric.value > 4000) rating = 'poor';
        break;
      case 'FID': // First Input Delay
        if (metric.value > 100) rating = 'needs improvement';
        if (metric.value > 300) rating = 'poor';
        break;
      case 'CLS': // Cumulative Layout Shift
        if (metric.value > 0.1) rating = 'needs improvement';
        if (metric.value > 0.25) rating = 'poor';
        break;
      case 'FCP': // First Contentful Paint
        if (metric.value > 1800) rating = 'needs improvement';
        if (metric.value > 3000) rating = 'poor';
        break;
      case 'TTFB': // Time to First Byte
        if (metric.value > 800) rating = 'needs improvement';
        if (metric.value > 1800) rating = 'poor';
        break;
      case 'INP': // Interaction to Next Paint
        if (metric.value > 200) rating = 'needs improvement';
        if (metric.value > 500) rating = 'poor';
        break;
      default:
        break;
    }

    // In a production app, send this to an analytics endpoint (e.g., Google Analytics, Vercel Analytics)
    // Example: sendToAnalytics(metric);

    // Only log in development or if the rating is poor/needs improvement
    if (process.env.NODE_ENV === 'development' || rating !== 'good') {
      console.log(`[Web Vitals] ${metric.name}: ${Math.round(metric.value)} (${rating})`);
    }
  });

  return null;
}
